var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isIcon)?_c('v-icon',[_vm._v(" "+_vm._s(_vm.item))]):_c('Place',{attrs:{"place":_vm.item}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dea77d4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlotMachine/SlotMachineWheelItem.vue
// module id = null
// module chunks = 